// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.msg[data-v-6a13bbfa] {\n  color: gray;\n  margin-top: -25px;\n}\n", ""]);
// Exports
module.exports = exports;
